import {
  Box,
  Grid2,
  Rating,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import {
  StyledTableBodyTableCell,
  StyledTableTitleTableCell,
  TableContainerBorder,
} from "../../../../common-components/StyledComponents";

function StrengthWeak({ size }) {
  // Static content for strengths and weaknesses
  const strengths = [
    {
      id: 5.0,
      skill: (
        <>
          {" "}
          <b style={{ fontWeight: 600 }}>Future-State Thinking –</b> Exceptional
          ability to articulate where the customer experience must go, not just
          where it is today,
        </>
      ),
      rating: "5.0",
      score: 96,
      topSkill: "Jane Cooper",
      justification: (
        <>
          <b style={{ fontWeight: 600 }}>Future-State Thinking –</b> Exceptional
          ability to articulate where the customer experience must go, not just
          where it is today,
        </>
      ),
    },
    {
      id: 5.0,
      skill: (
        <>
          <b style={{ fontWeight: 600 }}>Customer-Centric Lens – </b>
          Consistently frames decisions around customer impact rather than
          organizational convenience,
        </>
      ),
      rating: "5.0",
      score: 88,
      topSkill: "Olivia",
      justification:
        "Customer-Centric Lens – Consistently frames decisions around customer impact rather than organizational convenience",
    },
    {
      id: 4.0,
      skill: (
        <>
          <b style={{ fontWeight: 600 }}> Strategic Influence – </b>
          Credible with senior leadership; able to unify diverse functions
          around a common vision
        </>
      ),
      rating: "4",
      score: 80,
      topSkill: "Esther Howard",
      justification:
        "Strategic Influence – Credible with senior leadership; able to unify diverse functions around a common vision",
    },
  ];

  const weaknesses = [
    {
      id: 5.0,
      skill: (
        <>
          {" "}
          <b style={{ fontWeight: 600 }}>Execution Detail Blind Spots – </b> May
          underappreciate delivery complexity or operational constraints,
        </>
      ),
      rating: "5.0",
      score: 96,
      topSkill: "Jane Cooper",
      justification:
        "Execution Detail Blind Spots – May underappreciate delivery complexity or operational constraints",
    },
    {
      id: 5.0,
      skill: (
        <>
          <b style={{ fontWeight: 600 }}>Dependence on Strong Operators –</b>
          Effectiveness is maximized only when paired with execution-heavy
          leaders
        </>
      ),
      rating: "5.0",
      score: 88,
      topSkill: "Olivia",
      justification:
        "Dependence on Strong Operators – Effectiveness is maximized only when paired with execution-heavy leaders",
    },
    {
      id: 4.0,
      skill: (
        <>
          <b style={{ fontWeight: 600 }}> Strategic Influence – </b>
          Credible with senior leadership; able to unify diverse functions
          around a common vision
        </>
      ),
      rating: "4",
      score: 80,
      topSkill: "Esther Howard",
      justification:
        "Strategic Influence – Credible with senior leadership; able to unify diverse functions around a common vision",
    },
  ];

  const getRatingColor = (rating) => {
    if (rating > 4) return "#28A745";
    if (rating > 2) return "#F79009";
    return "#DC3545";
  };

  const renderSkills = (skills, title) => (
    <TableContainerBorder sx={{ marginTop: "0px !important" }}>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableTitleTableCell sx={{ width: "50%" }}>
              {title}
            </StyledTableTitleTableCell>
            <StyledTableTitleTableCell sx={{ width: "50%" }} align="center">
              {"Rating"}
            </StyledTableTitleTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {skills?.map((item, index) => (
            <Tooltip
              key={index}
              title={item?.justification || "No justification provided"}
              placement="top"
              arrow
            >
              <TableRow hover>
                <StyledTableBodyTableCell>
                  {item?.skill}
                </StyledTableBodyTableCell>
                <TableCell align="right">
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-end"
                    sx={{ gap: "10px", marginRight: "20px !important" }}
                  >
                    <Rating
                      value={parseFloat(item?.rating)}
                      precision={0.5}
                      readOnly
                      sx={{
                        color: "#FFA500",
                        fontSize: "24px",
                        mr: 1,
                      }}
                    />
                    <Box sx={{ width: "40px" }}>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "16px",
                          color: "#101828",
                        }}
                      >
                        {item?.score}%
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            </Tooltip>
          ))}
        </TableBody>
      </Table>
    </TableContainerBorder>
  );

  return (
    <Grid2 container spacing={4} justifyContent="center" marginTop={"0.5rem"}>
      <Grid2 size={size}>
        {renderSkills(strengths, "Strengths / Unique Value")}
      </Grid2>
      <Grid2 size={size}>{renderSkills(weaknesses, "Weakness / Gaps")}</Grid2>
    </Grid2>
  );
}

export default StrengthWeak;
